// extracted by mini-css-extract-plugin
export var alert = "LoginDialog-module--alert--6sceV";
export var box = "LoginDialog-module--box--ymAVH";
export var component = "LoginDialog-module--component--DVik-";
export var description = "LoginDialog-module--description--Iq9YP";
export var headline = "LoginDialog-module--headline--cCHrF";
export var list = "LoginDialog-module--list--Za-w4";
export var logo = "LoginDialog-module--logo--lOfAV";
export var nav = "LoginDialog-module--nav--QveiG";
export var wrapper = "LoginDialog-module--wrapper--kkJ6o";